import * as AuthActions from '../actions/auth';

const INITIAL_STATE = {
  accessToken: null,
  isAuthenticated: false,
  profile: null,
  error: null,
  loading: false
};

function authReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case AuthActions.LOGIN:
      return Object.assign({}, state, {
        loading: true,
        error: null
      });
    case AuthActions.LOGIN_SUCCESS:
      return Object.assign({}, state, {
        loading: true,
        accessToken: action.payload
      });
    case AuthActions.FETCH_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        profile: action.payload,
        error: null,
        isAuthenticated: true
      });
    case AuthActions.FETCH_PROFILE_FAILED:
      return Object.assign({}, INITIAL_STATE, {
        accessToken: null,
        isAuthenticated: false,
        profile: null,
        loading: false,
        error: action.payload
      });
    case AuthActions.RESET_PASSWORD_FAILED:
      return Object.assign({}, INITIAL_STATE, {
        loading: false,
        error: action.payload
      });
    case AuthActions.LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export default authReducer;


// WEBPACK FOOTER //
// ./src/reducers/auth.js